module.exports = __webpack_public_path__ + "images/banando-8b156f9d.png";